export default __webpack_public_path__ + "static/media/loginpage.088a2dcc.svg";